import React, { useMemo } from 'react';

import { Checkbox, VStack } from '../../core-ui';

type Props<T> = {
  items: Iterable<T>;
  selectedItems: Set<T>;
  renderLabel: (item: T) => string;
  onSelectionChange: (selection: Set<T>) => void;
};

export default function CheckboxList<T>(props: Props<T>) {
  let { items, selectedItems, renderLabel, onSelectionChange } = props;

  let array = useMemo(() => {
    return Array.isArray(items) ? items : Array.from(items);
  }, [items]);

  return (
    // Using CheckboxGroup makes isChecked ignore initial prop
    <VStack align="baseline">
      {array.map((item, index) => {
        return (
          <Checkbox
            key={index}
            isChecked={selectedItems.has(item)}
            onChange={() => {
              let newSelectedItems = new Set(selectedItems);
              newSelectedItems.has(item)
                ? newSelectedItems.delete(item)
                : newSelectedItems.add(item);
              onSelectionChange(newSelectedItems);
            }}
            value={index}
          >
            {renderLabel(item)}
          </Checkbox>
        );
      })}
    </VStack>
  );
}
